import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import VehiculoUsadoForm from './vehiculos-usados/VehiculoUsadoForm';
import InformacionAduaneraManager from './vehiculos-usados/InformacionAduaneraManager';

const ComplementoVehiculosUsados = (props) => {
  let initialState = props.data || { Version: '1.0' };

  const [state, setState] = useState({
    data: { ...initialState },
    isValid: false,
    isInformacionAduaneraEditing: false
  });

  const { data, isValid } = state;

  const handleOnChange = (event) => {
    const newState = {
      ...state,
      data: {
        ...state.data,
        ...event.data
      },
      isValid: event.isValid
    };

    setState(newState);
  }

  const handleOnInformacionAduaneraChange = (data) => {
    const newState = {
      ...state,
      data: {
        ...state.data,
        ...data
      },
    };

    setState(newState);
  }

  const handleOnAdd = () => {
    const complemento = {
      VehiculoUsado: data
    };

    props.onChange(complemento);

    clearState();
  }

  const clearState = () => {
    setState({
      ...state,
      data: {
        Version: '1.0'
      }
    });
  }

  const handleOnCancel = () => {
    props.onCancel('VehiculoUsado');

    clearState();
  }

  return (
    <>
      <div className="pb-4 text-right">
        <strong className="text-black text-upper">Complemento Vehículos usados</strong>
      </div>

      <div className="pb-4">
        <div className="section pt-2">

          <Form autoComplete="off">

            <VehiculoUsadoForm data={ data } onChange={ handleOnChange } />

            <InformacionAduaneraManager data={ data } onChange={ handleOnInformacionAduaneraChange } />

            <div className="py-2"></div>

            <Row className="pb-3 text-right">
              <Col>
                <Button variant="secondary"
                  className="mr-3"
                  onClick={ handleOnCancel }
                >
                  Cancelar
                </Button>

                <Button variant="secondary"
                  disabled={ !isValid }
                  onClick={ handleOnAdd }
                >
                  Agregar complemento
                </Button>
              </Col>
            </Row>

          </Form>
        </div>
      </div>
    </>
  );
}

export default ComplementoVehiculosUsados;